import { render } from "./index.vue?vue&type=template&id=35c250eb&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./style/index.less?vue&type=style&index=0&id=35c250eb&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c250eb"],['__file',"src/views/user-setting/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35c250eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35c250eb', __exports__)) {
    console.log('reload')
    api.reload('35c250eb', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=35c250eb&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('35c250eb', render)
  })

}


export default __exports__